// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* STYLE POUR RADIOTYPE */
.stylPieChart {
    padding: 0 !important;
    margin-top: -12% !important;
    margin-bottom: -15%;
}`, "",{"version":3,"sources":["webpack://./src/components/reponseTypes/reponse.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;AACvB","sourcesContent":["/* STYLE POUR RADIOTYPE */\r\n.stylPieChart {\r\n    padding: 0 !important;\r\n    margin-top: -12% !important;\r\n    margin-bottom: -15%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
